import { Sync } from "@material-ui/icons";

export default {
    id: "sync",
    title: "Check for product updates",
    icon: Sync,
};
